const isDevEnv = () => {
  return process.env.REACT_APP_WORKING_ENV === 'Production';
};

export const getBaseUrl = () => {
  return isDevEnv() ? '' : process.env.REACT_APP_BACKEND_API;
};
